import { cloneDeep } from 'lodash';
import * as TYPES from './types';

const initialState = {
  list: [],
  fetching: false,
  errorMessages: null,
  errorMessagesProfile: null,
  isCreated: false,
  isCopied: false,
  createdPublicTemplate: {},
  total: 0,
};
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TYPES.GET_PUBLIC_TEMPLATES_REQUEST:
      return { ...state, fetching: true, errorFetching: false };

    case TYPES.UPDATE_PUBLIC_TEMPLATE_REQUEST:
    case TYPES.DELETE_PUBLIC_TEMPLATE_REQUEST:
      return { ...state, fetching: true };

    case TYPES.COPY_PUBLIC_TEMPLATE_REQUEST:
      return { ...state, fetching: true, isCopied: false };

    case TYPES.CREATE_PUBLIC_TEMPLATE_REQUEST:
      return { ...state, fetching: true, isCreated: false };

    case TYPES.DELETE_PUBLIC_TEMPLATE_ERROR:
    case TYPES.UPDATE_PUBLIC_TEMPLATE_ERROR:
    case TYPES.COPY_PUBLIC_TEMPLATE_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
        isCopied: false,
      };
    case TYPES.CREATE_ERRORS:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
      };
    case TYPES.CREATE_PUBLIC_TEMPLATE_SUCCESS:
      return {
        ...state,
        list: [payload, ...state.list],
        fetching: false,
        total: state.total + 1,
        isCreated: true,
      };
    case TYPES.UPDATE_PUBLIC_TEMPLATE_SUCCESS:
      const list = cloneDeep(state.list);
      const index = list.findIndex((item) => item.id === payload.id);
      if (index !== -1) list[index] = payload;
      return {
        ...state,
        list,
        fetching: false,
        isCreated: true,
      };
    case TYPES.GET_PUBLIC_TEMPLATES_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        list: [...payload.publicTemplates],
        fetching: false,
      };
    }

    case TYPES.DELETE_PUBLIC_TEMPLATE_SUCCESS: {
      const list = cloneDeep(state.list);
      const index = list.findIndex((item) => item.id === payload);
      if (index !== -1) list.splice(index, 1);
      return {
        ...state,
        list,
        fetching: false,
        total: state.total - 1,
      };
    }

    case TYPES.CLEAR_PUBLIC_TEMPLATES_STATE: {
      return {
        ...state,
        fetching: false,
        errorMessages: null,
        errorMessagesProfile: null,
        isCreated: false,
        createdPublicTemplate: {},
      };
    }

    case TYPES.CLEAR_ERRORS: {
      return { ...state, errorMessages: null };
    }

    case TYPES.INIT_REDUCER:
      return {
        ...initialState,
        list: state.list,
        errorMessages: null,
        errorMessagesProfile: null,
      };

    case TYPES.COPY_PUBLIC_TEMPLATE_SUCCESS: {
      return {
        ...state,
        fetching: false,
        isCopied: true,
      };
    }

    case TYPES.CLEAR_PUBLIC_TEMPLATE_COPIED: {
      return {
        ...state,
        isCopied: false,
      };
    }

    default:
      return { ...state };
  }
};

export default reducer;
